<template>
    <form @submit.prevent="onSubmit" class="font_Montserrat">
      <div class="v2_color_primary_teal v2_font_weight_semibold v2_font_size_18">
        Ideal Career Opportunity Name:
      </div>      
      <b-form-group class="my-2">
        <b-form-input
          type="text"
          v-model="$v.title.$model"
          placeholder="Ideal Career Opportunity Name"
          :state="validateState('title')"
          class="p-3 phairify-border-grey height_auto v2_font_size_18 v2_color_black form-control"
        />
        <b-form-invalid-feedback>
          Name is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-button
        size="sm"
        class="mt-2 px-4 cancel-button float-right mx-2"
        variant="v2_white"
        @click="onCancel"
      >
        Cancel
      </b-button>
      <b-button
        type="submit"
        size="sm"
        class="float-right mt-2 px-4"
        variant="v2_primary"
        :disabled="isLoading"
      >
        <b-spinner v-if="isLoading" small />
        <span v-else>Save</span>
      </b-button>
    </form>
  </template>
  
  <script>
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';
  
  export default {
    name: 'JobProfileTitleIntialCard',
    props: {
      initialData: {
        validator: (prop) => typeof prop === 'object' || prop === null,
        default: null,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    mixins: [validationMixin],
    data: function () {
      return {
        title: this.initialData ? this.initialData.title : '',
      };
    },
    validations: {
      title: { required },
    },
    computed: {
      isJobProfileNew: function () {
        return this.$route.params && this.$route.params.isNew;
      },
    },
    methods: {
      onSubmit: function () {
        this.$v.$touch();
        if (this.$v.$anyError) {
          return;
        }
        this.$emit('form-submit', this.title);
        this.$v.$reset();
      },
      validateState: function (name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
      },
      onCancel: function () {        
          this.$emit('cancel');        
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  @import '../../../../sass/variables_mixins';
  
  .input-label {
    @include phairify_body_copy;
    font-weight: bold;
    color: $phairify_primary_color_teal;
  }
  .cancel-button {
    width: 120px !important;
    height: 30px !important;
    line-height: 1px !important;
    border: 1px solid #CB444A !important;
    border-radius: 0 !important;
    color: #CB444A !important;
    background-color: #FFFFFF !important;
  }
  .cancel-button:hover:not(.disabled) {
    background-color: #CB444A !important;
    color: #FFFFFF !important;
  }
  </style>
  